import React from "react";
import "./Button.css";

const Button = ({ text, className, href, newTab }) => {
  return (
    <div className={className}>
      <span className="main-button">
        {text}
      </span>
    </div>
  );
}

export default Button;